<template>
  <div>
    <AgentComponent no-agent-info>
      <LazyAgentCall />
      <LazyTranslationTools />
    </AgentComponent>
  </div>
</template>
